import { useState } from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  name: string;
  onRelease: () => void;
  onDelete: () => void;
  isBusy: boolean;
}

export function DutyScheduleRowMenu({ name, onRelease, onDelete, isBusy }: Props) {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  function handleSelect(action: () => void) {
    setAnchor(null);
    action();
  }

  return (
    <>
      <IconButton
        size="small"
        disabled={isBusy}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
        aria-label={t("dutySchedule.menu.ariaLabel", { name })}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(event) => event.stopPropagation()}
      >
        <MenuItem onClick={() => handleSelect(onRelease)}>
          <ListItemIcon>
            <CheckCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("dutySchedule.menu.release")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelect(onDelete)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>{t("dutySchedule.menu.delete")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
